import { ReactNode } from 'react';

export enum IconType {
  Home = 'home',
  Functional = 'functional',
  Dynamic = 'dynamic',
}

export interface ITextProps {
  name: string;
  iconType: IconType;
  refSrc?: string;
}

export interface IWrapperProps {
  teamName: string;
  teamType: number;
}

export interface CopyProps {
  pathname: string;
  width: number;
  height: number;
}

export interface FilterChip {
  name: string;
  id: number;
  icon: ReactNode;
  label: string;
  isActive: boolean;
  filterRef: string;
}

export interface TeamInterface {
  id: number;
  name: string;
  isActive: boolean;
  type: string;
  isVisible: boolean | null;
  isFavorite: boolean;
  theme: string;
  managerName: string;
  myRole: string | null;
  memberCount: number;
  okrsCount: number;
}
